import { render, staticRenderFns } from "./form-button.vue?vue&type=template&id=6c2f9456&scoped=true&"
import script from "./form-button.vue?vue&type=script&lang=js&"
export * from "./form-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f9456",
  null
  
)

export default component.exports